export default {
  tags: {
    default: 'Standaard',
    visible_to: 'Zichtbaar voor',
    not_visible_to: 'Niet zichtbaar voor',
  },
  labels: {
    inclusive: 'Inclusief',
    exclusive: 'Exclusief',
    public: 'Openbaar',
  },
  buttons: {
    edit: 'Bewerken',
    delete: 'Verwijderen',
  },
};
